// AcknowledgementStatus on the API: Sent = 0, Viewed = 1, Acknowledged = 2.
export const ACKNOWLEDGEMENT_STATUS = {
    Sent: 0,
    Viewed: 1,
    Acknowledged: 2,
} as const;

export interface AcknowledgementRecipientDTO {
    id: number;
    status: number;
    email: string;
    acknowledgedDate: string | null;
}

export interface RiskAssessmentAcknowledgementDetailsDTO {
    isExpired: boolean;
    documentName: string | null;
}

export interface RiskAssessmentAcknowledgementFileDTO {
    acknowledgementRecipient: AcknowledgementRecipientDTO;
    file: {
        fileContents: string;
        contentType: string;
        fileDownloadName: string | null;
    };
}
